import React, { useState, useEffect, useCallback } from "react";

import { useParams } from 'react-router-dom';
import {
  Box,
  Input,
  Text,
  Heading,
  Button,
  useToast,
  useColorModeValue,
  Flex,
  VStack,
  Tbody,
  Table,
  Tr,
  Td,
  Th,
  Thead,
  IconButton,
  HStack,
  Badge,
  Select,
  useDisclosure,

} from "@chakra-ui/react";
import axios from "axios";
import { FiTrash, FiCheck, FiX, FiEdit } from "react-icons/fi";
import { jwtDecode } from "jwt-decode";
import { PracticeSet,QuestionSet, PracticeSetQset, QuestionSetCategory,PracticeSetSection, PracticeSetGroup } from '../../Platform/Common/types';
import { addMinutes } from 'date-fns'; // You can also manually add mins without this
import ReactSelect from 'react-select';
import { useNavigate } from "react-router-dom";
import { Product } from '../../Platform/Common/types';

interface PracticeSetGroupProps {
    practiceSetId:number;
    sectionId: number;
    groupId : number;
    isPsetEditing:boolean;

    availableQuestionSets: QuestionSet[];
    allQuestionSets: QuestionSet[];

    onCommitComplete: () => Promise<void>;

    onGroupDeleted: (sectionId:number, groupId: number) => void; 
    canDelete: boolean;
  }

  
  const PracticeSetGroupQsets: React.FC<PracticeSetGroupProps> = ({ practiceSetId, sectionId, groupId, isPsetEditing, availableQuestionSets, allQuestionSets, onCommitComplete, onGroupDeleted, canDelete }) => {
    // ────────────────────────────────────────────────────────────────────────────
    // Theme & routing hooks
    // ────────────────────────────────────────────────────────────────────────────

    const cardbg = useColorModeValue("blue.50", "blue.700");

    const navigate = useNavigate();
    const toast = useToast();

  
    // ────────────────────────────────────────────────────────────────────────────
    // State: core practiceSet, question-sets, mappings
    // ────────────────────────────────────────────────────────────────────────────

  
    // const [questionSets, setQuestionSets] = useState<QuestionSet[]>([]);

    const [practiceSetGroup, setPracticeSetGroup] = useState<PracticeSetGroup>();
    
    const [questionSetCategories, setQuestionSetCategories] = useState<QuestionSetCategory[]>([]);

    const [isPracticeSetGroupEdited, setIsPracticeSetGroupEdited] = useState(false);
  
    type EditableMapping = PracticeSetQset & { isDraft?: boolean };

    const [mappings, setMappings] = useState<EditableMapping[]>([]);
    const [isMappingEdited, setIsMappingEdited] = useState(false);

    // ===== [QSET CATEGORY FILTER] per-row, UI-only category filter state START =====
    // Keyed by row index. NOT part of EditableMapping / PracticeSetQset --
    // never sent to the backend, never stored in mappings. Purely narrows
    // the Question Set dropdown's options for whichever row is currently
    // in draft/edit mode. Populated only while a row is being added or
    // edited, and cleaned up on confirm/cancel.
    const [categoryFilters, setCategoryFilters] = useState<Record<number, number>>({});
    // ===== [QSET CATEGORY FILTER] per-row, UI-only category filter state END =====

    // const [allQuestionSets, setAllQuestionSets] = useState<QuestionSet[]>([]);
  
  
    // ────────────────────────────────────────────────────────────────────────────
    // Mode & button logic
    // ────────────────────────────────────────────────────────────────────────────
  

      const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );

        const buttonHoverBg = useColorModeValue(
          'blue.200',
          'blue.500'
        );

  
    // ────────────────────────────────────────────────────────────────────────────
    // API fetchers
    // ────────────────────────────────────────────────────────────────────────────

    // Write fetchPracticeSetCategories, API has been written and then use Accordion logic - take help from ReviewCourseTerms


    const fetchPracticeSetGroup = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<PracticeSetGroup>(`${b2c_apiurl}/practice-set/${practiceSetId}/section/${sectionId}/group/${groupId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setPracticeSetGroup(data);
    };
  
    const fetchQuestionSetCategories = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<QuestionSetCategory[]>(`${b2c_apiurl}/qset-categories`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setQuestionSetCategories(data);
    };
  
    const fetchPracticeSetQsetMappings = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<PracticeSetQset[]>(`${b2c_apiurl}/practice-set/${practiceSetId}/section/${sectionId}/group/${groupId}/qset-mappings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setMappings(data);
    };
  

    // ────────────────────────────────────────────────────────────────────────────
    // Derived state effects
    // ────────────────────────────────────────────────────────────────────────────

    // 1) On load —  fetch everything
    useEffect(() => {
      (async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
          await fetchPracticeSetGroup();
/*           await fetchAllQuestionSets();
          await fetchAvailableQuestionSets(); */
          await fetchQuestionSetCategories();
          await fetchPracticeSetQsetMappings();

      })();
    }, [practiceSetId]);
  

  
  // ────────────────────────────────────────────────────────────────────────────
// Mapping helpers
// ────────────────────────────────────────────────────────────────────────────

// helper to know if a draft row exists
const hasDraftMappingRow = () => mappings.some(m => m.isDraft);

// backup storage while editing an existing row
const [mappingBackups, setMappingBackups] = useState<Record<number, PracticeSetQset>>({});


const remainingQSetCount =
  allQuestionSets.length -
  new Set(mappings.map(m => m.question_set_id).filter(Boolean)).size;

const isAddDisabled =
  hasDraftMappingRow() || remainingQSetCount <= 0;


// ────────────────────────────────────────────────────────────────────────────
// IMPORTANT: Practice Set uses persisted ordering → always maintain sequence_number
// This replaces the old "sequence" UI-only concept used in Groups.
// ────────────────────────────────────────────────────────────────────────────
const resequence = (rows: PracticeSetQset[]) =>
  rows.map((m, i) => ({
    ...m,
    sequence_number: i + 1,   // ← persisted order
  }));

// ===== [QSET CATEGORY FILTER] helper to remove one row's filter entry without destructuring-omit START =====
// A destructuring-omit pattern (const { [idx]: _, ...rest } = obj) on a
// Record<number, number> triggers a TS index-signature widening error
// (adds `| undefined`) in this project's tsconfig strictness. Using a
// shallow copy + delete avoids that inference issue entirely while
// producing the identical result.
const removeCategoryFilter = (idx: number) => {
  setCategoryFilters(prev => {
    const next: Record<number, number> = { ...prev };
    delete next[idx];
    return next;
  });
};
// ===== [QSET CATEGORY FILTER] helper to remove one row's filter entry without destructuring-omit END =====

// ────────────────────────────────────────────────────────────────────────────
// Add a *draft* row (only if none exists)
// ────────────────────────────────────────────────────────────────────────────
const addMapping = () => {
//  fetchAvailableQuestionSets();
  if (hasDraftMappingRow()) return;

  setMappings(prev =>
    resequence([
      ...prev,
      {
        practice_set_id: practiceSetId,
        question_set_id: 0,
        group_id: groupId,
        sequence_number: 0, // will be corrected by resequence()
        isDraft: true,
      },
    ])
  );

  setIsMappingEdited(true);
};

// ────────────────────────────────────────────────────────────────────────────
// Turn an existing row into edit mode
// ────────────────────────────────────────────────────────────────────────────
const editMapping = (idx: number) => {
  if (hasDraftMappingRow()) return;

  setMappingBackups(b => ({ ...b, [idx]: { ...mappings[idx] } }));

  // ===== [QSET CATEGORY FILTER] seed this row's filter from the qset's current category START =====
  // So editing an existing row doesn't reset the filter to blank -- the
  // dropdown opens already narrowed to the category the qset already
  // belongs to, matching what the user would expect to see.
  const currentQSet = allQuestionSets.find(
    (q) => q.question_set_id === mappings[idx].question_set_id
  );
  if (currentQSet) {
    setCategoryFilters(prev => ({ ...prev, [idx]: currentQSet.category_id } as Record<number, number>));
  }
  // ===== [QSET CATEGORY FILTER] seed this row's filter from the qset's current category END =====

  setMappings(prev =>
    prev.map((m, i) => (i === idx ? { ...m, isDraft: true } : m))
  );
};

// ────────────────────────────────────────────────────────────────────────────
// Confirm the draft row
// ────────────────────────────────────────────────────────────────────────────
const confirmDraftMapping = (idx: number) => {
  const m = mappings[idx];

  if (!m.question_set_id) {
    toast({ title: "Please select a Question Set", status: "warning" });
    return;
  }

  setMappings(prev =>
    prev.map((m, i) => (i === idx ? { ...m, isDraft: false } : m))
  );

  // remove backup snapshot
  setMappingBackups(b => {
    const { [idx]: _, ...rest } = b;
    return rest;
  });

  // ===== [QSET CATEGORY FILTER] clear this row's filter -- not needed once confirmed =====
  // View mode derives the displayed category from the qset itself
  // (selectedCategory below), so the filter state has no further purpose
  // for this row once it's no longer a draft.
  removeCategoryFilter(idx);

  setIsMappingEdited(true);
};

// ────────────────────────────────────────────────────────────────────────────
// Cancel the draft row
// ────────────────────────────────────────────────────────────────────────────
const cancelDraftMapping = (idx: number) => {
  if (mappingBackups.hasOwnProperty(idx)) {
    // existing row → restore original
    setMappings(prev =>
      prev.map((m, i) =>
        i === idx ? { ...mappingBackups[idx], isDraft: false } : m
      )
    );

    setMappingBackups(b => {
      const { [idx]: _, ...rest } = b;
      return rest;
    });
  } else {
    // brand new row → remove it and resequence
    setMappings(prev => resequence(prev.filter((_, i) => i !== idx)));
  }

  // ===== [QSET CATEGORY FILTER] discard this row's filter on cancel =====
  removeCategoryFilter(idx);

  setIsMappingEdited(true);
};

// ────────────────────────────────────────────────────────────────────────────
// Delete mapping
// ────────────────────────────────────────────────────────────────────────────
const deleteMapping = (idx: number) => {
  setMappings(prev => resequence(prev.filter((_, i) => i !== idx)));
  setIsMappingEdited(true);
};

// ────────────────────────────────────────────────────────────────────────────
// Update mapping (no resequencing — order unchanged)
// ────────────────────────────────────────────────────────────────────────────
const updateMapping = (idx: number, updates: Partial<EditableMapping>) => {
  setMappings(prev =>
    prev.map((m, i) => (i === idx ? { ...m, ...updates } : m))
  );
  setIsMappingEdited(true);
};

// ===== [QSET CATEGORY FILTER] category filter change handler START =====
// Changing the category filter narrows the Question Set dropdown to that
// category. The previously selected question_set_id (if any) may not
// belong to the new category, so it's cleared to force a fresh, valid
// selection rather than silently leaving a stale/invalid qset selected.
// This never touches mapping.category or any persisted field -- category
// is not, and never becomes, part of the mapping payload sent to the API.
const handleCategoryFilterChange = (idx: number, categoryId: number) => {
  setCategoryFilters(prev => ({ ...prev, [idx]: categoryId } as Record<number, number>));
  updateMapping(idx, { question_set_id: 0 });
};
// ===== [QSET CATEGORY FILTER] category filter change handler END =====


const getAvailableQuestionSets = (currentIndex: number) => {
  const currentId = mappings[currentIndex]?.question_set_id;

  // Collect all selected IDs in this group except current row
  const selectedIds = mappings
    .map((m, idx) => (idx !== currentIndex ? m.question_set_id : null))
    .filter(Boolean);

  // Remove already-selected ones from available list
  let filtered = availableQuestionSets.filter(
    q => !selectedIds.includes(q.question_set_id)
  );

  // ===== [QSET CATEGORY FILTER] narrow by this row's selected category, if any START =====
  // Optional convenience filter only -- if no category has been chosen
  // for this row yet, the full (mutual-exclusivity-filtered) list is
  // shown unchanged, exactly as before this requirement existed.
  const categoryFilter = categoryFilters[currentIndex];
  if (categoryFilter) {
    filtered = filtered.filter(q => q.category_id === categoryFilter);
  }
  // ===== [QSET CATEGORY FILTER] narrow by this row's selected category, if any END =====

  // Ensure current value is still visible during edit
  if (
    currentId &&
    !filtered.some(q => q.question_set_id === currentId)
  ) {
    const existing = allQuestionSets.find(
      q => q.question_set_id === currentId
    );
    if (existing) {
      return [...filtered, existing];
    }
  }

  return filtered;
};




    // ────────────────────────────────────────────────────────────────────────────
    // Form handlers
    // ────────────────────────────────────────────────────────────────────────────
  
    // ────────────────────────────────────────────────────────────────────────────
    // Save / Create / Update / Publish / Cancel / Terminate
    // ────────────────────────────────────────────────────────────────────────────
        const handleUpdatePracticeSetQsetGroup = async () => {
          const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
          // guard

          try {
                await axios.put(`${b2c_apiurl}/practice-set/${practiceSetId}/group/${groupId}/update`, practiceSetGroup, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
                });
                toast({ title: "PracticeSet Group updated", status: "success" });
                setIsPracticeSetGroupEdited(false);

            if (isMappingEdited) {
              await axios.delete(`${b2c_apiurl}/practice-set/${practiceSetId}/group/${groupId}/delete-mappings`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
              });
              await axios.post(`${b2c_apiurl}/practice-set/${practiceSetId}/group/${groupId}/create-mappings`, mappings, {
                headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
              });
            }
    
            toast({ title: "PracticeSetQsetGroup updated", status: "success" });
            setIsMappingEdited(false);

            await onCommitComplete();

  
          } catch (err) {
            console.error(err);
            toast({ title: "Error updating PracticeSetQsetGroup", status: "error" });
          }
        };
      
        const handleSavePracticeSet = () => {
          handleUpdatePracticeSetQsetGroup();
        };

                const handleInputChange = (e: React.ChangeEvent<any>) => {
                      const { name, value } = e.target;
                        setPracticeSetGroup(prev => {
                            if (!prev) return prev; // data not loaded yet → do nothing safely
        
                            return {
                            ...prev,
                            [name]: value,
                            };
                        });
                      setIsPracticeSetGroupEdited(true);
                    };

          
            const handleDeletePracticeSetGroup = async () => {
              const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
              // guard
    
              try {
    
                    await axios.delete(`${b2c_apiurl}/practice-set/${practiceSetId}/group/${groupId}/delete`, {
                        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
                    });
    
                    toast({ title: "Practice Set Group Deleted", status: "success" });
    
                    onGroupDeleted(sectionId, groupId);
                    await onCommitComplete();
      
              } catch (err) {
                console.error(err);
                toast({ title: "Error updating PracticeSetQsetGroup", status: "error" });
              }
            };
                          
                    
                
  

  return (
    <Box  p={4}  borderRadius="md" as="main" mx="auto" bgColor={cardbg} boxShadow="md">


          <Box
          p={4}
          borderRadius="md"
          bg={cardbg}
          boxShadow="sm"
          >
          <Flex align="flex-start" gap={3}>
              {/* Sequence Badge */}
              <Text
              fontSize="sm"
              fontWeight="bold"
              color="gray.500"
              minW="40px"
              pt="6px"
              >
              #{practiceSetGroup?.sequence_number}
              </Text>
      
              {/* Title + Description Area (takes remaining width) */}
              <Box flex="1">
              {!isPsetEditing && (
                  <>
                  <Text fontSize="lg" fontWeight="semibold" lineHeight="1.2">
                      {practiceSetGroup?.title || "–"}
                  </Text>
                  </>
              )}
      
              {isPsetEditing && practiceSetGroup && (
                  <VStack spacing={1} align="stretch">
                  <Input
                      name="title"
                      variant="flushed"
                      fontSize="lg"
                      fontWeight="semibold"
                      px={0}
                      value={practiceSetGroup.title}
                      onChange={handleInputChange}
                      _focus={{ boxShadow: "none" }}
                  />
    
                  </VStack>
              )}
              </Box>
      
              {/* Delete Icon — gets its OWN space now */}
              {isPsetEditing && canDelete && (
              <IconButton
                  aria-label="Delete Group"
                  icon={<FiTrash />}
                  variant="ghost"
                  size="lg"
                  color="gray.500"
                  alignSelf="center"
                  _hover={{ color: "red.500", bg: "transparent" }}
                  onClick={() => {
                  if (window.confirm("Delete this group? This cannot be undone.")) {
                      handleDeletePracticeSetGroup();
                  }
                  }}
              />
              )}
          </Flex>
          </Box>
      

        {/* PracticeSet Question Set Mapping */}
   <Box borderRadius="md" borderWidth={"thin"} mt={2} p={2}>
  
        {(mappings.length === 0)? (
        <Text fontSize="sm" color="gray.500" mt={3}>
            No question sets in this group.
        </Text>
        ) : (

        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              {/* ===== [QSET CATEGORY FILTER] column order swapped: Category now first, Question Set second ===== */}
              <Th>Category</Th>
              <Th>Question Set</Th>
              {isPsetEditing && <Th>Actions</Th>}
            </Tr>
          </Thead>

          <Tbody>
            {mappings.map((mapping, index) => {
              const selectedQSet = allQuestionSets.find(
                (qs) => qs.question_set_id === mapping.question_set_id
              );

              const selectedCategory = questionSetCategories.find(
                (cat) => cat.category_id === selectedQSet?.category_id
              );

              return (
                <Tr key={index}>
                  {/* ===== [QSET CATEGORY FILTER] Category cell moved first; draft rows get an editable filter dropdown START ===== */}
                  <Td>
                    {mapping.isDraft ? (
                      <Select
                        size="sm"
                        placeholder="Select category"
                        value={categoryFilters[index] ?? ''}
                        onChange={(e) =>
                          handleCategoryFilterChange(index, Number(e.target.value))
                        }
                      >
                        {questionSetCategories.map((cat) => (
                          <option key={cat.category_id} value={cat.category_id}>
                            {cat.category_name}
                          </option>
                        ))}
                      </Select>
                    ) : (
                      selectedCategory?.category_name || '–'
                    )}
                  </Td>
                  {/* ===== [QSET CATEGORY FILTER] Category cell moved first; draft rows get an editable filter dropdown END ===== */}

                  <Td>
                    <Select
                      size="sm"
                      placeholder="Select question set"
                      value={mapping.question_set_id || ''}
                      isDisabled={!mapping.isDraft}
                      onChange={(e) =>
                        updateMapping(index, {
                          question_set_id: Number(e.target.value),
                        })
                      }
                    >
                      {getAvailableQuestionSets(index).map((qs) => (
                        <option key={qs.question_set_id} value={qs.question_set_id}>
                          {qs.title}
                        </option>
                      ))}
                    </Select>
                  </Td>

                  {isPsetEditing && (
                    <Td>
                      {mapping.isDraft ? (
                        <HStack spacing={1}>
                          <IconButton
                            aria-label="Confirm"
                            icon={<FiCheck />}
                            size="sm"
                            colorScheme="green"
                            isDisabled={!mapping.question_set_id}
                            onClick={() => confirmDraftMapping(index)}
                          />
                          <IconButton
                            aria-label="Cancel"
                            icon={<FiX />}
                            size="sm"
                            colorScheme="red"
                            onClick={() => cancelDraftMapping(index)}
                          />
                        </HStack>
                      ) : (
                        <HStack spacing={1}>
                          <IconButton
                            aria-label="Edit"
                            icon={<FiEdit />}
                            colorScheme="blue"
                            size="sm"
                            onClick={() => editMapping(index)}
                            isDisabled={hasDraftMappingRow()}
                          />
                          <IconButton
                            aria-label="Delete"
                            icon={<FiTrash />}
                            size="sm"
                            colorScheme="red"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to remove this Question Set?"
                                )
                              ) {
                                deleteMapping(index);
                              }
                            }}
                            isDisabled={hasDraftMappingRow()}
                          />
                        </HStack>
                      )}
                    </Td>
                  )}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
         )}

          {(isPsetEditing) && ( 
            <Button
                onClick={addMapping}
                        size="xs"
                        borderRadius="sm"
                        colorScheme="cyan"
                        mt={2} ml={4}
                isDisabled={isAddDisabled}
                >
                + Q Set
                </Button>
                 )} 


        </Box>

             {(isPsetEditing) && ( 
                    <Button
                    mt={2}
                    colorScheme="teal"
                    size="sm"
                    borderRadius="sm"
                    onClick={handleSavePracticeSet}
                    isDisabled={ (!isMappingEdited || hasDraftMappingRow()) && !isPracticeSetGroupEdited}
                    >
                    Commit
                    </Button>
                 )} 
    </Box>
  );
};

export default PracticeSetGroupQsets;